import React from 'react';
import { motion } from 'framer-motion';
export function Production() {
  const images = [{
    url: 'https://images.unsplash.com/photo-1562157873-818bc0726f68?w=600',
    caption: 'Apparel Printing Process'
  }, {
    url: 'https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=600',
    caption: 'Quality Inspection'
  }, {
    url: 'https://images.unsplash.com/photo-1523381210434-271e8be1f52b?w=600',
    caption: 'Ready to Ship'
  }, {
    url: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?w=600',
    caption: 'Your Brand, Our Craft'
  }];
  return <section className="py-24 bg-white" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-78">
          <h2 className="text-4xl md:text-5xl font-black mb-4" data-id="element-79">
            See How We Make Your Apparel
          </h2>
          <div className="w-24 h-2 bg-black mx-auto" data-id="element-80"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-81">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative overflow-hidden border-4 border-black bg-gray-100" data-id="element-82">
              <div className="aspect-w-16 aspect-h-12 w-full h-64 sm:h-80" data-id="element-83">
                <img src={img.url} alt={img.caption} className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition-all duration-500" data-id="element-84" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 bg-black text-white p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-85">
                <p className="font-display font-bold uppercase tracking-wider text-lg text-center" data-id="element-86">
                  {img.caption}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}